


































































































// import {getEmployeeList,enableOrDisableEmployee} from '@/api/employee'

import {getConsultantList,enableOrDisableConsultant} from '@/api/consultant'
import router from '@/router';
export default  {
  //模型数据
  data() {
    return {
      name: '', //咨询师姓名，对应上面的输入框
      page: 1, //页码
      pageSize: 10, //每页记录数
      total: 0, //总记录数
      records: [] //当前页要展示的数据集合
    }
  },
  created() {
    this.pageQuery()
  },
  methods: {
    //分页查询
    pageQuery() {
      //准备请求参数
      const params = {name:this.name,page:this.page,pageSize:this.pageSize}

      //发送Ajax请求，访问后端服务，获取分页数据
      getConsultantList(params).then(res => {
        if(res.data.code === 1) {
          this.total = res.data.data.total
          this.records = res.data.data.records
        }
      }).catch(err => {
        this.$message.error('请求出错了：' + err.message)
      })
    },
    //pageSize发生变化时触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageQuery()
    },
    //page发生变化时触发
    handleCurrentChange(page) {
      this.page = page
      this.pageQuery()
    },
    //启用禁用咨询师账号
    handleStartOrStop(row) {
      // if(row.username === 'admin'){
      //   this.$message.error('admin为系统的管理员账号，不能更改账号状态！')
      //   return
      // }

      //alert(`id=${row.id} status=${row.status}`)

    //弹出确认提示框
    this.$confirm('确认要修改当前咨询师账号的状态吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const p = {
            id: row.id,
            status: !row.status ? 1 : 0
          }

          enableOrDisableConsultant(p).then(res => {
            if(res.data.code === 1) {
              this.$message.success('咨询师的账号状态修改成功！')
              this.pageQuery()
            }
          })
        })
    },
    //跳转到新增咨询师页面（组件）
    handleAddConultant(){
      //路由跳转，跳转到新增咨询师组件
      this.$router.push('/consultant/add')
    },
    //跳转到修改咨询师页面（组件）
    handleUpdateCon(row) {
      // if(row.username === 'admin'){
      //   this.$message.error('admin为系统的管理员账号，不能修改！')
      //   return 
      // }

      //跳转到修改页面，通过地址栏传递参数
      this.$router.push({
        path: '/consultant/add',
        query: {id: row.id}
      })
    }
  }
}
